"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDERS = void 0;

var _advancedInventoryManagement = require("./advancedInventoryManagement");

var _creditNotes = require("./creditNotes");

var _general = require("./general");

var _newOrder = require("./newOrder");

var _singleOrder = require("./singleOrder");

var ORDERS = {
  ADVANCED_INVENTORY_MANAGEMENT: _advancedInventoryManagement.ADVANCED_INVENTORY_MANAGEMENT,
  CREDIT_NOTES: _creditNotes.CREDIT_NOTES,
  GENERAL: _general.GENERAL,
  NEW_ORDER: _newOrder.NEW_ORDER,
  SINGLE_ORDER: _singleOrder.SINGLE_ORDER
};
exports.ORDERS = ORDERS;